<mat-card class="thin-card">
  <mat-card-title>
    Reset Password
  </mat-card-title>

  <form #resetPasswordForm="ngForm" class="example-form">
    <div fxLayout="column">
      <mat-form-field class="sigla-full-width">
        <input
          matInput
          placeholder="New Password"
          [(ngModel)]="newPassword"
          name="newPassword"
          type="password"
          required
        />
      </mat-form-field>

      <mat-form-field class="sigla-full-width">
        <input
          matInput
          placeholder="Confirm Password"
          [(ngModel)]="confirmPassword"
          name="confirmPassword"
          type="password"
          required
        />
      </mat-form-field>

      <button
        [disabled]="!resetPasswordForm.form.valid"
        mat-raised-button
        (click)="resetPassword()"
        type="submit"
        color="primary"
      >
        RESET PASSWORD
      </button>
    </div>
  </form>
</mat-card>
